var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "#CCA9A9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Account"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1110,
    transform: "translate(-358 -512)",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 691315839",
    clipPath: "url(#clip0_1914_918)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1082,
    height: 1030,
    transform: "translate(-16 -448)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 691315840"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -16,
    y: -448,
    width: 1082,
    height: 1030,
    rx: 10,
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Image 13",
    clipPath: "url(#clip1_1914_918)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.37 43.78C7.92 41.91 0 32.89 0 22C0 9.9 9.9 0 22 0C34.1 0 44 9.9 44 22C44 32.89 36.08 41.91 25.63 43.78L24.42 42.79H19.58L18.37 43.78Z",
    fill: "url(#paint0_linear_1914_918)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M30.5805 28.1601L31.5705 22.0001H25.7405V17.7101C25.7405 15.9501 26.4005 14.6301 29.0405 14.6301H31.9005V9.02008C30.3605 8.80008 28.6005 8.58008 27.0605 8.58008C22.0005 8.58008 18.4805 11.6601 18.4805 17.1601V22.0001H12.9805V28.1601H18.4805V43.6701C19.6905 43.8901 20.9005 44.0001 22.1105 44.0001C23.3205 44.0001 24.5305 43.8901 25.7405 43.6701V28.1601H30.5805Z",
    fill: "white"
  }))))))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1914_918",
    x1: 22,
    y1: 41.4814,
    x2: 22,
    y2: -0.998832,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0062E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#19AFFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1914_918"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1082,
    height: 1030,
    fill: "white",
    transform: "translate(-16 -448)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1914_918"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.8c3c8dfe3cfcc9daf3ec1409950b7ce7.svg";
export { ForwardRef as ReactComponent };